import { CbhIcon } from "@clipboard-health/ui-components";
import { isNil } from "@clipboard-health/util-ts";
import { Alert } from "@mui/material";

import { useTimelinessBonusRedesignConfig } from "../../../ClipboardScore/hooks/featureFlags";

export function TimelinessAdjustmentInfoAlert() {
  const timelinessBonusRedesignConfig = useTimelinessBonusRedesignConfig();

  if (!timelinessBonusRedesignConfig.enabled || isNil(timelinessBonusRedesignConfig.goLiveDate)) {
    return null;
  }

  return (
    <Alert
      severity="info"
      icon={<CbhIcon type="info" />}
      sx={(theme) => ({
        marginBottom: theme.spacing(2),
      })}
    >
      {`As of ${timelinessBonusRedesignConfig.goLiveDate}: bonuses for on-time arrival will apply after your shift ends, instead of when you clock in. This change ensures you always get the right Clipboard Score adjustments based on your final timesheet.`}
    </Alert>
  );
}
